import {
    LegacyCard,
    DescriptionList,
    Page,
    Layout,
    TextField,
    BlockStack,
    Checkbox
} from "@shopify/polaris";
import {useCallback, useEffect} from 'react';
import { useState } from 'react';
import {useParams, useHistory} from 'react-router-dom';
import Api from '../../helpers/api';
import {useToast} from "@shopify/app-bridge-react";

const CreateApiUser = props => {
    const history = useHistory();
    const [form, setForm] = useState({
        name: '',
        csv_inventory_access: false,
    });
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    const save = () => {
        setLoading(true);
        Api
            .storeApiUser(form)
            .then( ({data}) => {
                toast.show("API User has been created");
                history.push(`/api-users/show/${data.data.id}`);
            })
            .catch(() => toast.show("Error occurred, please try again."))
            .finally(() => setLoading(false));
    }

    const handleInputChange = useCallback((value, id) => {
        setForm({
            ...form,
            [id]: value,
        });
    }, [form]);

    return (
        <Page title={`New Api User`}
              backAction={{ content: 'Go back', onAction: () => history.go(-1) }}
              primaryAction={{
                  content: 'Save',
                  loading: loading,
                  disabled: !form.name?.length,
                  onAction() {
                      save();
                  }
              }}
        >
            <Layout>
                <Layout.Section variant={"fullWidth"}>
                    <LegacyCard sectioned>
                        <BlockStack gap={'200'}>
                            <DescriptionList items={[
                                { term: 'Name', 'description': <TextField requiredIndicator disabled={loading} label={'Name'} autoComplete={'off'} value={form.name} id={'name'} onChange={handleInputChange} /> },
                                { term: 'CSV Access', 'description': <Checkbox disabled={loading} checked={form.csv_inventory_access} id={'csv_inventory_access'} onChange={handleInputChange} /> },
                            ]} />
                        </BlockStack>
                    </LegacyCard>
                </Layout.Section>
            </Layout>
        </Page>
    );
}

export default CreateApiUser;
